export const goodsTypes =[{
    id:"0",
    url:require("../assets/general.png"),
    selectUrl:require("../assets/general_select.png"),
    value:"普通货物",
    defaultAmount:200000
},{
    id:"-1",
    url:require("../assets/cola.png"),
    selectUrl:require("../assets/coal_select.png"),
    value:"煤炭\/粮食等",
    defaultAmount:200000
},{
    id:"5",
    url:require("../assets/fresh.png"),
    selectUrl:require("../assets/fresh_select.png"),
    value:"生鲜",
    defaultAmount:50000
}, {
    id: "4",
    url:require("../assets/fragile.png"),
    selectUrl:require("../assets/fragile_select.png"),
    value: "易碎品",
    defaultAmount:100000
}];
export const amounts = {
    "0":[{content:"20万",amount:200000},{content:"30万",amount:300000},{content:"50万",amount:500000}],
    "-1":[{content:"20万",amount:200000},{content:"30万",amount:300000},{content:"50万",amount:500000}],
    "5":[{content:"5万",amount:50000},{content:"10万",amount:100000},{content:"20万",amount:200000}],
    "4":[{content:"10万",amount:100000},{content:"20万",amount:200000},{content:"30万",amount:300000}]
};